import { createRouter, createWebHistory } from "vue-router";
import Login from "../tracker/components/firebase-login.vue";
import Taller from "../tracker/components/packetracker/submodules/taller/taller.vue";
import Almacen from "../tracker/components/packetracker/submodules/almacenes/almacen.vue";
import Dashboard from "../tracker/components/packetracker/submodules/logistica/dashboard";
import CalculadoraCortes from "@/views/CalculadoraCortes.vue";
import Prohibido from "../views/Prohibido.vue";
import Home from "../views/Home.vue";
import Trabajo from "@/views/Trabajo.vue";
import MiPedido from "@/views/MiPedido.vue";
import firebase from "firebase/app";
import "firebase/auth";

const routes = [
  {
    path: "/inventario",
    name: "Inventario",
    meta: { requiresAuth: true },
    component: () => import("../tracker/components/packetracker/submodules/almacenes/reporte-inventario.vue"),
    props: (route) => ({ inventarioId: route.query.id }),

  },
  {
    path: "/calculadora-cortes",
    name: "Calculadora Cortes",
    meta: { requiresAuth: false },
    component: CalculadoraCortes,
  },
  {
    path: "/cortes",
    name: "Calculadora Cortes",
    meta: { requiresAuth: false },
    component: CalculadoraCortes,
  },
  {
    path: "/pedido",
    name: "Mi Pedido",
    meta: { requiresAuth: false },
    props: (route) => ({ orden: route.query.orden }),
    component: MiPedido,
  },
  {
    path: "/trabajo",
    name: "Mi trabajo",
    meta: { requiresAuth: false },
    props: (route) => ({ orden: route.query.orden }),
    component: MiPedido,
  },
  {
    path: "/rastreo",
    name: "Rastreo",
    meta: { requiresAuth: false },
    props: (route) => ({ orden: route.query.orden }),
    component: Trabajo,
  },
  {
    path: "/",
    name: "Home",
    meta: { requiresAuth: true },
    component: Home,
  },
  {
    path: "/logistica",
    name: "Dashboard",
    meta: { requiresAuth: true },
    component: Dashboard,
  },
  {
    path: "/almacen",
    name: "Almacen",
    meta: { requiresAuth: true },
    component: Almacen,
  },

  {
    path: "/taller",
    name: "Taller",
    meta: { requiresAuth: true },
    component: Taller,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/chofer",
    name: "Chofer",
    meta: { requiresAuth: true },

    component: () =>
      import("../tracker/components/packetracker/submodules/chofer/chofer.vue"),
  },
  {
    path: "/403",
    name: "Prohibido",
    component: Prohibido,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (requiresAuth && !(await firebase.getCurrentUser())) {
    next({ path: "/login", query: { redirect: to.fullPath } });
  } else {
    next();
  }
});

export default router;
